import { Meteor } from 'meteor/meteor';
import React from 'react';
import { moment } from 'moment';

import {
	Icon,
	Table,
	Checkbox,
	Button,
	Modal
} from '@sketchpixy/rubix';

export class ReservationModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
			visible: this.props.visible
        };
    }

	componentWillReceiveProps({ visible }) {
		this.setState({
			visible: visible
		});
	}

	render() {
		if (!this.props.reservation) return null;

		return (
			<Modal show={this.state.visible} lg aria-labelledby="contained-modal-title-lg" onHide={::this.props.onHide}>
				<Modal.Header closeButton>
					<Modal.Title id="contained-modal-title-lg">Réservation N°{this.props.reservation.id}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<strong>Informations sur les passagers :</strong><br/><br/>
					<div style={{'overflow': 'scroll'}}>
					<Table striped bordered condensed hover>
						<thead>
							<tr>
								<th>Nom</th>
								<th>Prénom</th>
								<th>Poids</th>
								<th>Age</th>
								<th>Téléphone</th>
								<th>Information</th>
							</tr>
						</thead>
						<tbody>
							{this.props.reservation.getPassengers().map((passenger) => {
								return (
									<tr>
										<td>{passenger.lastName}</td>
										<td>{passenger.firstName}</td>
										<td>{passenger.weight}kg</td>
										<td>{passenger.age} ans</td>
										<td>{passenger.phone}</td>
										<td>{passenger.info}</td>
									</tr>
								);
							})}
						</tbody>
					</Table>
					</div>
					<hr/>
					<strong>Note interne :</strong><br/><br/>
					<p>{this.props.reservation.infoReservation}</p>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={::this.props.onHide}>Fermer</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/reservations/components/ReservationModal.js
 **/